export default __webpack_public_path__ + "static/media/titulo.23bf1cd7.png";